import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { InsurancePeriodType } from '../../../api/useInsuranceQuery';

interface Props {
  label: string;
  fieldName:
    | 'DisabilityCoveragePeriod'
    | 'DisabilityEliminationPeriod'
    | 'LongTermCareCoveragePeriod'
    | 'LongTermCareEliminationPeriod';
  options: { label: string; value: InsurancePeriodType }[];
}

export const TimePeriod = ({ label, fieldName, options }: Props) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name={fieldName}
      render={({ field: { onChange, value, ...field } }) => (
        <InputNumberMask
          {...field}
          value={value && value.PeriodType !== InsurancePeriodType.Lifetime ? value.Value : ''}
          allowNegative={false}
          label={label}
          onValueChange={({ floatValue }) => onChange({ ...value, Value: floatValue })}
          maxLength={3}
          disabled={field.disabled || value?.PeriodType === InsurancePeriodType.Lifetime}
          selectorProps={{
            defaultValue: options.find(({ value: v }) => v === value?.PeriodType) || options[0],
            options,
            onChange: option => {
              const newValue = value?.Value || null;

              onChange({
                Value: option.value === InsurancePeriodType.Lifetime ? '' : newValue,
                PeriodType: option.value,
              });
            },
            ariaLabel: 'Select period type',
          }}
        />
      )}
    />
  );
};
